const orthodontics = {
  hero: {
    titlePrefix: "Advanced",
    titleAccent: "Orthodontics",
    titleSuffix: "For A Perfect Smile",
    description:
      "Achieve perfect alignment and a beautiful smile with our cutting-edge orthodontic treatments. Our expert team uses the latest technology to provide comfortable, effective solutions for all ages.",
    ctas: {
      primary: "Book a Consultation",
      secondary: "Explore Our Process",
    },
    patientAlt: "Happy Patient",
    patientCount: "1000+ Happy Patients",
    rating: "Rated 4.9 out of 5",
    imageAlt: "Advanced Orthodontic Treatment",
    tech: {
      calloutTitle: "Modern Techniques",
      calloutSubtitle: "Safe & Comfortable",
    },
  },
  benefits: {
    heading: "WHY CHOOSE OUR ORTHODONTIC CARE",
    intro:
      "Experience comprehensive orthodontic treatments with a focus on comfort, aesthetics, and long-term results.",
    items: [
      {
        title: "Perfect Alignment",
        description:
          "Achieve perfectly aligned teeth for a beautiful smile and improved bite functionality.",
      },
      {
        title: "Better Oral Health",
        description:
          "Straighter teeth are easier to clean, reducing the risk of tooth decay and gum disease.",
      },
      {
        title: "Advanced Technology",
        description:
          "Benefit from shorter treatment times with our modern orthodontic technologies.",
      },
      {
        title: "Customized Treatment",
        description:
          "Personalized treatment plans tailored to your specific dental needs and goals.",
      },
    ],
  },
  process: {
    heading: "OUR ORTHODONTIC PROCESS",
    intro:
      "A streamlined, comfortable journey to your perfect smile with our expert orthodontic team",
    imageAlt: "Orthodontic Treatment Process",
    calloutTitle: "Expert Care",
    calloutSubtitle: "Experienced Specialists",
    items: [
      {
        title: "Initial Consultation",
        description:
          "A thorough examination of your dental structure to assess your needs and discuss treatment options.",
      },
      {
        title: "Custom Treatment Plan",
        description:
          "Creating a personalized orthodontic plan tailored to your specific dental alignment needs.",
      },
      {
        title: "Active Treatment",
        description:
          "Regular adjustment appointments to ensure your treatment progresses as planned.",
      },
      {
        title: "Retention Phase",
        description:
          "Maintenance of your new smile with custom retainers after active treatment is complete.",
      },
    ],
  },
  faq: {
    heading: "FREQUENTLY ASKED QUESTIONS",
    intro:
      "Find answers to common questions about our orthodontic treatments",
    items: [
      {
        question: "How long does orthodontic treatment typically take?",
        answer:
          "Treatment duration varies based on individual needs, but typically ranges from 12 to 36 months. Factors affecting treatment time include the severity of alignment issues, patient age, and treatment compliance.",
      },
      {
        question: "What types of braces and orthodontic options do you offer?",
        answer:
          "We offer a comprehensive range of options including traditional metal braces, ceramic (clear) braces, self-ligating braces, and clear aligners like Invisalign. During your consultation, we'll recommend the best option for your specific case.",
      },
      {
        question: "Are orthodontic treatments painful?",
        answer:
          "You may experience mild discomfort or pressure after adjustments, but modern orthodontic techniques are designed to minimize pain. Any discomfort typically subsides within a few days and can be managed with over-the-counter pain relievers.",
      },
      {
        question: "How often will I need to visit for adjustments?",
        answer:
          "Most patients need adjustments every 4-8 weeks, depending on the treatment type and individual progression. We'll create a schedule tailored to your specific treatment plan.",
      },
      {
        question: "What happens after my braces are removed?",
        answer:
          "After active treatment, you'll enter the retention phase. You'll be fitted with retainers to maintain your new smile. Initially, you'll wear them full-time, then gradually transition to nighttime wear only. Regular check-ups will monitor your results.",
      },
    ],
    bottomLine: "Still have questions? We're here to help!",
    cta: "Contact Us",
  },
};

export default orthodontics;

